import { GS3Logo, LogoDefaultCompanies } from "@/assets/images";
import {
  TenantCard,
  TenantPageTemplate,
  TenantLoadingState,
} from "../features";
import { useLocalization } from "@i18n";
import { useDarkMode } from "@shared/hooks";
import { buildAssetUrl } from "@shared/utils";
import {
  useSelectTenantMutation,
  useTenantsQuery,
} from "../features/tenant-selection/api";

export default function TenantSelectionPage() {
  const { translate } = useLocalization();
  const [darkmode] = useDarkMode();
  const { data: tenants, isLoading, error: _error } = useTenantsQuery();
  const { mutate: selectTenant } = useSelectTenantMutation();

  const handleSelectTenant = (tenantId?: string) => {
    if (!tenantId) return;
    selectTenant({ tenantId });
  };

  if (isLoading) {
    return <TenantLoadingState />;
  }

  if (!tenants) {
    return null;
  }

  const selectTenent = (
    <div>
      <div className="flex justify-center">
        <div className="w-full px-4">
          <div className="flex justify-between items-center pb-6">
            <p className="text-h5">{translate("auth.selectClient")}</p>
          </div>
          <div className="grid gap-6 grid-cols-[repeat(auto-fit,minmax(360px,1fr))]">
            {[...(tenants ?? [])]
              .sort((a, b) => Number(b.hasAccess) - Number(a.hasAccess))
              .map((tenant, index) => (
                <TenantCard
                  key={tenant.tenantId + index}
                  description={tenant.complex}
                  imageUrl={
                    tenant.logo
                      ? buildAssetUrl(tenant.logo)
                      : LogoDefaultCompanies
                  }
                  handleClick={() => handleSelectTenant(tenant.tenantId)}
                  disabled={!tenant.hasAccess}
                  darkmode={darkmode}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <TenantPageTemplate logo={GS3Logo} tenantFormSelect={selectTenent} />
  );
}
